import { createFileRoute } from '@tanstack/react-router'

import { PartnersPage } from '@/pages/admin/partners/partners-page'
import { DEFAULT_PARTNERS_SEARCH, partnersSearchSchema } from '@/utils/partners-search-params'

export const Route = createFileRoute('/_private/admin/partners')({
  component: PartnersPage,
  // Single source of truth for filters / sort / page lives in the URL.
  // `.catch()` short-circuits to the default view on a malformed link so the
  // page paints; without it the schema would throw inside the router and
  // leave a marketing teammate staring at a blank screen for a bad query
  // string (e.g. a partner pasted a hand-edited URL).
  validateSearch: (search) => partnersSearchSchema.catch(DEFAULT_PARTNERS_SEARCH).parse(search),
})
